import VueI18n from 'vue-i18n'
import Vue from 'vue'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'es', // 语言标识
  messages: {
    zh: require('./lang/zh'), // 中文语言包
    es: require('./lang/es'), // 西文语言包
  },
})

export default i18n
